/**
 * TokenEntry — the index route for `/r/:token`. The emailed link carries no step, so this resolves
 * the session and redirects to the referee's furthest incomplete step (step restoration). It is
 * the whole "the link is the session, resumable per-step" behaviour in one place.
 */
import { Navigate } from 'react-router-dom';
import { SessionError, SessionLoading } from '@/components/SessionStates';
import { TerminalPage } from '@/components/TerminalPage';
import { RefereeApiError } from '@/lib/api-types';
import { useSession } from './useSession';

export function TokenEntry() {
  const session = useSession();

  if (session.isLoading) return <SessionLoading />;
  if (session.isError) {
    if (session.error instanceof RefereeApiError) {
      if (session.error.kind === 'not_found') return <TerminalPage kind="not-found" />;
      if (session.error.kind === 'gone') return <TerminalPage kind="expired" />;
    }
    return <SessionError onRetry={session.refetch} />;
  }
  if (!session.currentStep) return <SessionLoading />;

  return <Navigate to={`/r/${session.token}/${session.currentStep}`} replace />;
}
